module.exports = __webpack_public_path__ + "img/plus.10fa3bae.png";